import drugInput from './saveInputs/drugInput';

export default (drug) => {
  console.log('[DeleteDrugMutation] Building GraphQL mutation for drug:', drug);
  console.log('[DeleteDrugMutation] Drug ID:', drug?.id);

  const mutation = `
    deleteDrug (drug: {
        ${drugInput(drug)}
    })
`;

  console.log('[DeleteDrugMutation] Generated GraphQL mutation:', mutation);
  return mutation;
};
